const GratitudeIcon = (): JSX.Element => (
  <svg
    width="128"
    height="129"
    viewBox="0 0 128 129"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="65.4201"
      cy="71.4403"
      rx="41.7795"
      ry="41.7794"
      fill="url(#paint0_linear_1596_80432)"
    />
    <mask id="mask0_1596_80432" maskUnits="userSpaceOnUse" x="23" y="29" width="85" height="85">
      <ellipse cx="65.4201" cy="71.4403" rx="41.7795" ry="41.7794" fill="#E0F7E9" />
    </mask>
    <g mask="url(#mask0_1596_80432)">
      <path
        d="M82.1564 60.0057L88.9181 66.1489L76.9865 76.589C68.9332 77.237 60.895 75.1695 54.1537 70.7164L49.7531 67.8095C46.9549 65.9611 44.6173 63.4963 42.9197 60.6041L39.0786 54.0604C38.4321 52.9591 38.5499 51.57 39.3724 50.5931C40.6716 49.0504 43.09 49.1942 44.1972 50.8799L45.3102 52.5744C46.3152 54.1044 47.4474 55.5405 48.6923 56.8684C48.4063 56.0125 48.5919 55.0199 49.2909 54.3209C49.9627 53.6492 50.9587 53.4195 51.8568 53.7292L62.7387 57.4822C64.5871 58.1197 66.5681 58.2725 68.4924 57.9262L72.4417 57.2153C75.9375 56.586 79.5273 57.6171 82.1564 60.0057Z"
        fill="white"
        stroke="#3D3A62"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M82.1564 60.0057L88.9181 66.1489L76.9865 76.589C68.9332 77.237 60.895 75.1695 54.1537 70.7164L48.8042 67.1827C46.617 65.7379 44.6885 63.9353 43.0996 61.8504L36.5139 53.2093C35.6292 52.0484 35.6686 50.429 36.6088 49.3125C37.8488 47.8399 40.1142 47.8326 41.3638 49.2972L45.9477 54.6697C48.0747 57.1627 50.5741 59.3121 53.3574 61.0419L61.5748 66.1489L49.6612 58.138C48.364 57.2657 48.1855 55.4263 49.2909 54.3209C49.9627 53.6492 50.9587 53.4195 51.8568 53.7292L62.7387 57.4822C64.5871 58.1197 66.5681 58.2725 68.4924 57.9262L72.4417 57.2153C75.9375 56.586 79.5273 57.6171 82.1564 60.0057Z"
        fill="white"
        stroke="#3D3A62"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="78.3477"
        y="81.0925"
        width="23.7772"
        height="55.2758"
        rx="1.2383"
        transform="rotate(-45 78.3477 81.0925)"
        fill="#C9EBD6"
        stroke="#3D3A62"
        strokeWidth="2"
      />
      <path
        d="M82.1564 60.0057L88.9181 66.1489L76.9865 76.589C68.8418 77.2443 60.6672 75.7623 53.271 72.2895L49.3678 70.4568C46.1155 68.9298 43.2014 66.768 40.7967 64.0985L32.8467 55.273C31.7882 54.0979 31.7586 52.3222 32.7773 51.1124C33.9646 49.7025 36.1002 49.6001 37.417 50.89L42.5788 55.9465C45.6009 58.9068 49.1829 61.2348 53.1154 62.7943L61.5748 66.1489L49.6612 58.138C48.364 57.2657 48.1855 55.4263 49.2909 54.3209C49.9627 53.6492 50.9587 53.4195 51.8568 53.7292L62.7387 57.4822C64.5871 58.1197 66.5681 58.2725 68.4924 57.9262L72.4417 57.2153C75.9375 56.586 79.5273 57.6171 82.1564 60.0057Z"
        fill="white"
        stroke="#3D3A62"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="72.2617"
        y="81.421"
        width="29.3319"
        height="12.9259"
        rx="1.2383"
        transform="rotate(-45 72.2617 81.421)"
        fill="#C9EBD6"
        stroke="#3D3A62"
        strokeWidth="2"
      />
      <circle cx="81.2141" cy="84.5434" r="1.49145" fill="#3D3A62" />
    </g>
    <path
      d="M57.1701 32.1482L63.4677 38.005C63.6478 38.1725 63.7379 38.2563 63.8393 38.2907C63.9435 38.326 64.0565 38.326 64.1607 38.2907C64.2621 38.2563 64.3522 38.1725 64.5323 38.005L64.5323 38.005L70.8299 32.1482C72.6224 30.4812 72.8395 27.7192 71.3296 25.7926L71.0731 25.4652C69.2789 23.1758 65.7055 23.5624 64.4423 26.1825C64.2638 26.5529 63.7362 26.5529 63.5577 26.1825C62.2945 23.5624 58.7211 23.1758 56.9269 25.4652L56.6704 25.7926C55.1605 27.7192 55.3776 30.4812 57.1701 32.1482Z"
      fill="#00DC5A"
      stroke="#00DC5A"
      strokeWidth="2"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1596_80432"
        x1="107.2"
        y1="29.6609"
        x2="23.6407"
        y2="113.22"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EEF7FD" />
        <stop offset="0.7242" stopColor="#DFF8E9" />
      </linearGradient>
    </defs>
  </svg>
);

export default GratitudeIcon;
